import { DragIndicator } from "@mui/icons-material";
import { Box, IconButton } from "@mui/material";
import { memo, useState } from "react";

const DraggableList = memo(function DraggableList({ reorderList, children = [], isStatic = false }) {

  const [draggedId, setDraggedId] = useState(null);
  const [dropTargetId, setDropTargetId] = useState(null);

  const handleDragStart = (event, id) => {
    setDraggedId(id);
    event.dataTransfer.setData('text/plain', String(id));
    event.dataTransfer.effectAllowed = 'move';
  };

  const handleDragOver = (event, id) => {
    event.preventDefault();
    if (draggedId !== null && draggedId !== id) setDropTargetId(id);
  };

  const handleDragLeave = () => {
    setDropTargetId(null);
  };

  const handleDrop = (event, id) => {
    event.preventDefault();
    if (draggedId === null || dropTargetId !== id) {
      handleDragEnd();
      return;
    }
    reorderList(draggedId, id);
    handleDragEnd();
  };

  const handleDragEnd = () => {
    setDraggedId(null);
    setDropTargetId(null);
  }

  return <Box
    sx={{
      display: 'flex',
      flexDirection: 'column',

    }}
  >
    {children.map((el, index) => {
      const isDragged = draggedId === index;
      const isOver = dropTargetId === index;

      return (
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'center',
            justifyContent: 'center',
            gap: 0,
            py: 0,
            backgroundColor: isDragged ? 'rgba(0,0,0,0.05)' : 'transparent',
            opacity: isDragged ? 0.6 : 1,
            transform: isDragged ? 'scale(1.02)' : 'none',
            transition: 'transform 0.2s, opacity 0.2s',
            borderTop: isOver ? '2px dashed rgb(175,175,175)' : 'none',
          }}
          onDragOver={(e) => handleDragOver(e, index)}
          onDragLeave={handleDragLeave}
          onDrop={(e) => handleDrop(e, index)}
          key={index}
        >
          <IconButton
            draggable={!isStatic}
            disableRipple
            size="small"
            onDragStart={(e) => handleDragStart(e, index)}
            onDragEnd={handleDragEnd}
            sx={{ cursor: 'grab', '&:active': { cursor: 'grabbing' }, color: '#464646', p: 0.5, opacity: 1, background: 'none' }}
          >
            <DragIndicator />
          </IconButton>
          {el}
        </Box>
      )
    })}
    <Box
      sx={{ height: 20, borderRadius: 1, borderTop: dropTargetId === -1 ? '2px dashed rgb(175,175,175)' : 'none' }}
      onDragOver={(e) => handleDragOver(e, -1)}
      onDragLeave={handleDragLeave}
      onDrop={(e) => handleDrop(e, -1)}
    >
    </Box>
  </Box>
});

export default DraggableList;